import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import DownloadCertificatesComponent from '../../components/download-certificates/index';
import {
    downloadCertificates,
    downloadCertificatesSetup,
    onDatePickerChange,
    setClassroomId,
    setGroupId,
    setTeacherId
} from './actions';

class DownloadCertificatesContainer extends Component {
    componentDidMount() {
        this.props.downloadCertificatesSetup();
    }

    render() {
        return (<div>
            <DownloadCertificatesComponent
                {...this.props}
                loading={this.props.fetchingAcademicYear || this.props.fetchingSummary} />
        </div>);
    }
}

DownloadCertificatesContainer.propTypes = {
    downloadCertificatesSetup: PropTypes.func,
    fetchingAcademicYear: PropTypes.bool,
    fetchingSummary: PropTypes.bool
};

const mapStateToProps = state => ({
    ...state.downloadCertificates,
    classes: state.classRoll.classrooms,
    product: state.product,
    teachers: state.teacherRoll.teachers,
    yearGroups: state.schoolRoll.yearGroups
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        downloadCertificates,
        downloadCertificatesSetup,
        onDatePickerChange,
        setClassroomId,
        setGroupId,
        setTeacherId
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(DownloadCertificatesContainer));



// WEBPACK FOOTER //
// ./app/containers/download-certificates/index.js